export default __webpack_public_path__ + "static/testi-3-5abe5a988af4cb9bb0ed5204e4d20da0.png";